import { useEffect, useRef } from "react";

export const Phone = ({ src, video, play = false, className = "", alt = "" }) => {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (play) v.play().catch(() => {});
    else v.pause();
  }, [play]);

  return (
    <div className={`relative aspect-[9/19] rounded-[1.2rem] border-[4px] border-zinc-900 bg-black shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)] ring-1 ring-white/15 sm:rounded-[2.2rem] sm:border-[7px] ${className}`}>
      <div className="absolute left-1/2 top-1.5 z-10 h-2.5 w-10 -translate-x-1/2 rounded-full bg-black sm:top-2 sm:h-4 sm:w-16" />
      <div className="h-full w-full overflow-hidden rounded-[0.95rem] bg-white sm:rounded-[1.7rem]">
        {video ? (
          <video ref={ref} src={video} poster={src} muted loop playsInline preload="metadata" aria-label={alt} className="h-full w-full object-cover" />
        ) : (
          <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover object-top" />
        )}
      </div>
      <div className="pointer-events-none absolute inset-0 rounded-[0.95rem] bg-gradient-to-tr from-transparent via-white/5 to-white/20 sm:rounded-[1.7rem]" />
    </div>
  );
};

export const PlayVideo = ({ src, poster, play, className = "" }) => {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (play) v.play().catch(() => {});
    else v.pause();
  }, [play]);
  return <video ref={ref} src={src} poster={poster} muted loop playsInline preload="metadata" className={className} />;
};

export const Laptop = ({ src, className = "", alt = "" }) => (
  <div className={`relative ${className}`}>
    <div className="rounded-t-2xl border-[8px] border-b-[14px] border-zinc-800 bg-black ring-1 ring-white/10">
      <div className="aspect-[16/10] overflow-hidden bg-white">
        <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover object-center" />
      </div>
    </div>
    <div className="mx-[-6%] h-3 rounded-b-xl bg-gradient-to-b from-zinc-500 to-zinc-700 shadow-[0_30px_50px_-10px_rgba(0,0,0,0.8)]" />
  </div>
);

export const Chip = ({ children, className = "" }) => (
  <span className={`rounded-full border border-white/15 bg-[rgba(9,9,11,0.75)] px-3 py-1.5 font-mono text-[11px] uppercase tracking-widest text-white backdrop-blur-md ${className}`}>
    {children}
  </span>
);
